import { render, staticRenderFns } from "./GestorCentralizadoModalAgregarAdicional.vue?vue&type=template&id=0daa6df0&"
import script from "./GestorCentralizadoModalAgregarAdicional.vue?vue&type=script&lang=js&"
export * from "./GestorCentralizadoModalAgregarAdicional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports